import { render, staticRenderFns } from "./ChangeBankCardDialog.vue?vue&type=template&id=63064ea0&scoped=true&lang=pug&"
import script from "./ChangeBankCardDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeBankCardDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63064ea0",
  null
  
)

export default component.exports